"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokensForSizeClass = exports.getStickerSizeClass = void 0;
const SizeClassMaxAreas = {
    MATBOARD_WALL_MAP: {
        SMALL: 6.5,
        MEDIUM: 23,
        LARGE: 10000,
    },
    MATBOARD_WALL_MAP_SINGLE: {
        SMALL: 6,
        MEDIUM: 20,
        LARGE: 10000,
    },
    VEHICLE_MAP: {
        SMALL: 4,
        MEDIUM: 13.3,
        LARGE: 10000,
    },
    VINYL_WALL_MAP: {
        SMALL: 6,
        MEDIUM: 20,
        LARGE: 10000,
    },
};
const SIZE_CLASS_TOKEN_PRICES = {
    SMALL: 0.5,
    MEDIUM: 1,
    LARGE: 2,
};
function getStickerSizeClass(opening, scale, outputType) {
    var _a, _b, _c;
    if (opening.stickerSizeClass) {
        // If the opening has an explicit size class then use that.
        return opening.stickerSizeClass;
    }
    else {
        // Otherwise calculate it.
        const bbox = (_b = (_a = opening.layout.cut) === null || _a === void 0 ? void 0 : _a.bbox) !== null && _b !== void 0 ? _b : (_c = opening.layout.print) === null || _c === void 0 ? void 0 : _c.bbox;
        const area = (bbox.width * bbox.height * scale) / (72 * 72);
        return getStickerSizeClassByArea(area, outputType);
    }
}
exports.getStickerSizeClass = getStickerSizeClass;
function getStickerSizeClassByArea(areaSqIn, outputType) {
    const sizeClassLimits = SizeClassMaxAreas[outputType];
    const group = Object.keys(sizeClassLimits).find(sizeClass => areaSqIn <= sizeClassLimits[sizeClass]);
    if (group) {
        return group;
    }
    else {
        return "LARGE";
    }
}
function getTokensForSizeClass(sizeClass) {
    return SIZE_CLASS_TOKEN_PRICES[sizeClass];
}
exports.getTokensForSizeClass = getTokensForSizeClass;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RpY2tlclNpemVVdGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9TdGlja2VyU2l6ZVV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUtBLE1BQU0saUJBQWlCLEdBQXFEO0lBQzFFLGlCQUFpQixFQUFFO1FBQ2pCLEtBQUssRUFBRSxHQUFHO1FBQ1YsTUFBTSxFQUFFLEVBQUU7UUFDVixLQUFLLEVBQUUsS0FBSztLQUNiO0lBQ0Qsd0JBQXdCLEVBQUU7UUFDeEIsS0FBSyxFQUFFLENBQUM7UUFDUixNQUFNLEVBQUUsRUFBRTtRQUNWLEtBQUssRUFBRSxLQUFLO0tBQ2I7SUFDRCxXQUFXLEVBQUU7UUFDWCxLQUFLLEVBQUUsQ0FBQztRQUNSLE1BQU0sRUFBRSxJQUFJO1FBQ1osS0FBSyxFQUFFLEtBQUs7S0FDYjtJQUNELGNBQWMsRUFBRTtRQUNkLEtBQUssRUFBRSxDQUFDO1FBQ1IsTUFBTSxFQUFFLEVBQUU7UUFDVixLQUFLLEVBQUUsS0FBSztLQUNiO0NBQ0YsQ0FBQztBQUVGLE1BQU0sdUJBQXVCLEdBQTBDO0lBQ3JFLEtBQUssRUFBRSxHQUFHO0lBQ1YsTUFBTSxFQUFFLENBQUM7SUFDVCxLQUFLLEVBQUUsQ0FBQztDQUNULENBQUM7QUFFRixTQUFnQixtQkFBbUIsQ0FDakMsT0FBdUIsRUFDdkIsS0FBYSxFQUNiLFVBQTZCOztJQUU3QixJQUFJLE9BQU8sQ0FBQyxnQkFBZ0IsRUFBRTtRQUM1QiwyREFBMkQ7UUFDM0QsT0FBTyxPQUFPLENBQUMsZ0JBQWdCLENBQUM7S0FDakM7U0FBTTtRQUNMLDBCQUEwQjtRQUMxQixNQUFNLElBQUksR0FBRyxNQUFBLE1BQUEsT0FBTyxDQUFDLE1BQU0sQ0FBQyxHQUFHLDBDQUFFLElBQUksbUNBQUksTUFBQSxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssMENBQUUsSUFBSSxDQUFDO1FBQ3BFLE1BQU0sSUFBSSxHQUFHLENBQUMsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsTUFBTSxHQUFHLEtBQUssQ0FBQyxHQUFHLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQyxDQUFDO1FBRTVELE9BQU8seUJBQXlCLENBQUMsSUFBSSxFQUFFLFVBQVUsQ0FBQyxDQUFDO0tBQ3BEO0FBQ0gsQ0FBQztBQWZELGtEQWVDO0FBRUQsU0FBUyx5QkFBeUIsQ0FDaEMsUUFBZ0IsRUFDaEIsVUFBNkI7SUFFN0IsTUFBTSxlQUFlLEdBQUcsaUJBQWlCLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDdEQsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsQ0FBQyxJQUFJLENBQzdDLFNBQVMsQ0FBQyxFQUFFLENBQUMsUUFBUSxJQUFJLGVBQWUsQ0FBQyxTQUFTLENBQUMsQ0FDaEMsQ0FBQztJQUN0QixJQUFJLEtBQUssRUFBRTtRQUNULE9BQU8sS0FBSyxDQUFDO0tBQ2Q7U0FBTTtRQUNMLE9BQU8sT0FBTyxDQUFDO0tBQ2hCO0FBQ0gsQ0FBQztBQUVELFNBQWdCLHFCQUFxQixDQUFDLFNBQTJCO0lBQy9ELE9BQU8sdUJBQXVCLENBQUMsU0FBUyxDQUFDLENBQUM7QUFDNUMsQ0FBQztBQUZELHNEQUVDIn0=